module.exports = __webpack_public_path__ + "static/img/empty.63bf5b78.png";